export const checkForAllWords = (query: string, string: string) => {
  const q = query.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().split(' ');
  const regExp = new RegExp(q.map(w => `(?=.*${w})`).join(''), 'i');
  return string.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().match(regExp);
};
